export default __webpack_public_path__ + "static/key-6ff823ba8ddd12353c33a5d8803813c5.png";